
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MetalRateMasterDialog extends Serenity.EntityDialog<MetalRateMasterRow, any> {
        protected getFormKey() { return MetalRateMasterForm.formKey; }
        protected getIdProperty() { return MetalRateMasterRow.idProperty; }
        protected getLocalTextPrefix() { return MetalRateMasterRow.localTextPrefix; }
        protected getNameProperty() { return MetalRateMasterRow.nameProperty; }
        protected getService() { return MetalRateMasterService.baseUrl; }
        protected getDeletePermission() { return MetalRateMasterRow.deletePermission; }
        protected getInsertPermission() { return MetalRateMasterRow.insertPermission; }
        protected getUpdatePermission() { return MetalRateMasterRow.updatePermission; }

        protected form = new MetalRateMasterForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.Rate);
            q.setTextRightAlign(this.form.LossPercent);
        }
 

    }
}